"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioLabel = void 0;
var React = require("react");
function RadioLabel(props) {
    var children = props.children;
    return (React.createElement("legend", null, children));
}
exports.RadioLabel = RadioLabel;
//# sourceMappingURL=RadioLabel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/RadioGroup/RadioLabel.js
// module id = 2379
// module chunks = 8